function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9zZWFyY2guanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2ljb25zL3NlYXJjaC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gU2VhcmNoKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgYXJpYS1sYWJlbD1cIlNlYXJjaFwiXG4gICAgICBkYXRhLXRlc3RpZD17dGVzdElkfVxuICAgID5cbiAgICAgIDxwYXRoXG4gICAgICAgIGQ9XCJNMTguMjQzIDE4LjI0M2E2IDYgMCAxMC04LjQ4NS04LjQ4NSA2IDYgMCAwMDguNDg1IDguNDg1em02Ljk2NCA1LjU1Yy45NDMuOTQzLS40NzEgMi4zNTctMS40MTQgMS40MTRsLTQuODg3LTQuODg3YTggOCAwIDExMS40MTQtMS40MTRsNC44ODcgNC44ODd6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuU2VhcmNoLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgU2VhcmNoO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function Search(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "aria-label": "Search",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M18.243 18.243a6 6 0 10-8.485-8.485 6 6 0 008.485 8.485zm6.964 5.55c.943.943-.471 2.357-1.414 1.414l-4.887-4.887a8 8 0 111.414-1.414l4.887 4.887z",
    fill: primaryColor
  }));
}

Search.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default Search;